import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface PaginationProps {
  page: number;
  pageCount: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
}
export function Pagination({
  page,
  pageCount,
  total,
  pageSize,
  onChange
}: PaginationProps) {
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const pages = pageList(page, pageCount);
  const arrow = 'flex h-8 w-8 items-center justify-center rounded-lg text-muted transition-colors duration-150 ease-out hover:bg-canvas hover:text-ink disabled:pointer-events-none disabled:opacity-40 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent';
  return <nav aria-label="Pagination" className="flex flex-col items-center justify-between gap-3 sm:flex-row" data-id="element-116" data-mp="3mkzexcw6tnul">
      <p className="text-xs text-muted" data-id="element-117" data-mp="2yv52uxjp03be">
        Showing <span className="font-semibold text-ink" data-id="element-118" data-mp="2tyemsa7w17pz">{from}–{to}</span> of <span className="font-semibold text-ink" data-id="element-119" data-mp="2tw26e1hs35f1">{total}</span>
      </p>
      <div className="flex items-center gap-1" data-id="element-120" data-mp="2op7eq8u41w3b">
        <button type="button" className={arrow} onClick={() => onChange(page - 1)} disabled={page <= 1} aria-label="Previous page" data-id="element-121" data-mp="2tok0eq98wx4b">
          <ChevronLeftIcon className="h-4 w-4" data-id="element-122" data-mp="2ygl9y4f149qn" />
        </button>
        {pages.map((p, i) => p === 'gap' ? <span key={`gap-${i}`} className="px-1 text-xs text-subtle" aria-hidden data-id="element-123" data-mp="32gc66nnbri2k">
              …
            </span> : <button key={p} type="button" onClick={() => onChange(p)} aria-current={p === page ? 'page' : undefined} className={`h-8 min-w-[32px] rounded-lg px-2 text-[13px] font-semibold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${p === page ? 'bg-accent text-on-accent' : 'text-muted hover:bg-canvas hover:text-ink'}`} data-id="element-124" data-mp="2apxvf0alylv4">
              {p}
            </button>)}
        <button type="button" className={arrow} onClick={() => onChange(page + 1)} disabled={page >= pageCount} aria-label="Next page" data-id="element-125" data-mp="1v1ysw4pyl7ge">
          <ChevronRightIcon className="h-4 w-4" data-id="element-126" data-mp="251pj3u7hl0ao" />
        </button>
      </div>
    </nav>;
}
function pageList(page: number, count: number): (number | 'gap')[] {
  if (count <= 7) return Array.from({
    length: count
  }, (_, i) => i + 1);
  const set = new Set([1, count, page - 1, page, page + 1].filter(p => p >= 1 && p <= count));
  const sorted = [...set].sort((a, b) => a - b);
  const out: (number | 'gap')[] = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) out.push('gap');
    out.push(p);
  });
  return out;
}